/**
 * MODULE: _shared/frontend/lib/frontend/utils/brainPreferenceEvents.ts
 * PURPOSE: Same-tab sync when learned brain preferences change (Settings dismiss → insight surfaces).
 * PUBLIC_API: BRAZN_BRAIN_PREFERENCES_CHANGED, notifyBrainPreferencesChanged
 * SIDE_EFFECTS: window CustomEvent dispatch
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 28 / 100 lines
 * RECENT: 2026-05-26 [2.2.1234] — Scoped preference events (`dashboard` vs `all`); promotion triggers full surface sync.
 */

export const BRAZN_BRAIN_PREFERENCES_CHANGED = 'brazn-brain-preferences-changed';

export type BrainPreferencesChangedDetail = {
  /** dashboard = Home brain strip only; all (default) = assistant + dashboard + CRM surfaces. */
  scope?: 'all' | 'dashboard';
};

/** Notify dashboard, assistant, CRM, and Pages brain surfaces to drop stale preference hints. */
export function notifyBrainPreferencesChanged(
  detail: BrainPreferencesChangedDetail = { scope: 'all' },
): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(BRAZN_BRAIN_PREFERENCES_CHANGED, { detail }));
}

/** Refresh Home dashboard brain queries after post-chat learning without re-running assistant catch-up. */
export function notifyBrainDashboardRefresh(): void {
  notifyBrainPreferencesChanged({ scope: 'dashboard' });
}
